<template>
  <div
      v-if="request"
  >
    <ErrorAlerta
        v-if="tipo === 'alerta'"
        :texto="texto"
        :showBtn="showBtn"
        @click="$emit('click')"
    />
    <ErrorVazio
        v-else-if="tipo === 'vazio'"
        :texto="texto"
        :showBtn="showBtn"
        @click="$emit('click')"
    />
    <ErrorInternet
        v-else-if="tipo === 'internet'"
        :texto="texto"
        :showBtn="showBtn"
        @click="$emit('click')"
    />
    <ErrorCarregar
        v-else-if="tipo === 'carregar'"
        :texto="texto"
        :showBtn="showBtn"
        @click="$emit('click')"
    />
  </div>
</template>

<script>
import ErrorAlerta from '@/components/Error/ErrorCarregar'
import ErrorInternet from '@/components/Error/ErrorInternet'
import ErrorVazio from '@/components/Error/ErrorVazio'
import ErrorCarregar from '@/components/Error/ErrorAlerta'

export default {
  name: 'ErrorHandler',
  components: { ErrorCarregar, ErrorVazio, ErrorInternet, ErrorAlerta },
  props: {
    request: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    tipo () {
      if (!this.request) {
        return ''
      }
      if (this.request.status) {
        return 'vazio'
      } else if (!this.request.code) {
        return 'carregar'
      } else {
        return 'carregar'
      }
    },
    texto () {
      if (this.request.code === 401) {
        return 'Sessão invalida.'
      }
      return null
    },
    showBtn () {
      return this.request.code !== 401
    }
  }
}
</script>
